export const SUPPORTED_RATIOS = {
    WH_1x1: 1,
    WH_4x3: 0.75,
    WH_16x9: 0.5625,
    WH_21x9: 0.42857143,
    WH_36x9: 0.25,
};

export const SUPPORTED_PERCENTAGE_RATIOS = {
    WH_1x1: "100%",
    WH_4x3: "75%",
    WH_16x9: "56.25%",
    WH_21x9: "42.857143%",
    WH_36x9: "25%",
};
